export default __webpack_public_path__ + "static/media/lusd.ddb6a6a7.webp";